import dayjs, { Dayjs } from "dayjs"
import { IServiceConfig } from "@/models/admin/serviceConfig/serviceConfig.types"
import { formatDate, formatDateTime } from "@/helpers/dateHelper"

export class ServiceConfig implements IServiceConfig {
  constructor(
    public id: number,
    public name: string,
    public value: string,
    public start: Dayjs | null,
    public end: Dayjs | null,
    public createdAt: Dayjs,
    public updatedAt: Dayjs | null,
    public deletedAt: Dayjs | null,
  ) {}

  get isActive(): boolean {
    if (this.deletedAt !== null) return false
    if (this.end === null) return true
    return this.end.isAfter(dayjs())
  }

  get startDisplay(): string {
    return this.start ? formatDateTime(this.start) : "—"
  }

  get endDisplay(): string {
    return this.end ? formatDateTime(this.end) : "—"
  }

  get createdAtDisplay(): string {
    return formatDateTime(this.createdAt)
  }

  get updatedAtDisplay(): string {
    return this.updatedAt ? formatDateTime(this.updatedAt) : "—"
  }

  get deletedAtDisplay(): string {
    return this.deletedAt ? formatDateTime(this.deletedAt) : "—"
  }

  get startDateDisplay(): string {
    return this.start ? formatDate(this.start) : "—"
  }

  get endDateDisplay(): string {
    return this.end ? formatDate(this.end) : "—"
  }

  get createdAtDateDisplay(): string {
    return formatDate(this.createdAt)
  }

  get updatedAtDateDisplay(): string {
    return this.updatedAt ? formatDate(this.updatedAt) : "—"
  }

  get deletedAtDateDisplay(): string {
    return this.deletedAt ? formatDate(this.deletedAt) : "—"
  }
}
